import { useState } from "react";
import { api } from "../../api/client";
import { ApiProblem, formatProblem } from "../../api/problemDetails";
import { useAppNavigate } from "../../app/router/router";

export function InvitationAcceptPage({ token }: { token: string }): React.JSX.Element {
  const navigate = useAppNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const submit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault(); setBusy(true); setError(null);
    try {
      await api.acceptInvitation(token, { email, password });
      navigate("/login", true);
    } catch (reason) { setError(reason instanceof ApiProblem ? formatProblem(reason) : "The invitation could not be accepted."); }
    finally { setBusy(false); }
  };
  return <main className="auth-page"><section className="auth-card"><p className="eyebrow">WORKSPACE INVITATION</p><h1>Join ContentForge</h1><p>Set credentials for the email address that received this one-time invitation.</p><form onSubmit={event => void submit(event)} noValidate>
    <label>Email<input type="email" autoComplete="email" value={email} onChange={event => setEmail(event.target.value)} required /></label>
    <label>Password<input type="password" autoComplete="new-password" minLength={8} value={password} onChange={event => setPassword(event.target.value)} required /></label>
    {error && <p className="field-error" role="alert">{error}</p>}
    <button className="button-primary" disabled={busy}>{busy ? "Accepting…" : "Accept invitation"}</button>
  </form></section></main>;
}
